import { createFileRoute } from "@tanstack/react-router";
import { PortalBriefsPage } from "@/features/briefs/PortalBriefsPage";
import { PortalFrame } from "@/features/portal-home/PortalFrame";

/** Briefs the client signs off, inside the portal frame so the client keeps the navigation. */
export const Route = createFileRoute("/portal/briefs")({ component: PortalBriefsRoute });

function PortalBriefsRoute() {
  return (
    <PortalFrame>
      <PortalBriefsPage />
    </PortalFrame>
  );
}
